import React from "react";

function Finished() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="25"
      enableBackground="new 0 0 512 512"
      viewBox="0 0 60 60"
    >
      <path
        fill="#cb8252"
        d="M32 5h10a3 3 0 013 3v48a3 3 0 01-3 3H4a3 3 0 01-3-3V8a3 3 0 013-3z"
        data-original="#cb8252"
      ></path>
      <path fill="#ecf0f1" d="M32 9h9v46H5V9h9z" data-original="#ecf0f1"></path>
      <path
        fill="#95a5a5"
        d="M32 5v4a1 1 0 01-1 1H15a1 1 0 01-1-1V5a1 1 0 011-1h4.13a4 4 0 017.74 0H31a1 1 0 011 1z"
        data-original="#95a5a5"
      ></path>
      <rect
        width="9"
        height="9"
        x="9"
        y="14"
        fill="#d1d4d1"
        data-original="#d1d4d1"
        rx="1"
      ></rect>
      <rect
        width="9"
        height="9"
        x="9"
        y="28"
        fill="#d1d4d1"
        data-original="#d1d4d1"
        rx="1"
      ></rect>
      <rect
        width="9"
        height="9"
        x="9"
        y="42"
        fill="#d1d4d1"
        data-original="#d1d4d1"
        rx="1"
      ></rect>
      <path
        fill="#4fba6f"
        d="M14 20a1 1 0 01-.707-.293l-1-1a1 1 0 011.414-1.414l.293.293 4.293-4.293a1 1 0 011.414 1.414l-5 5A1 1 0 0114 20zm0 14a1 1 0 01-.707-.293l-1-1a1 1 0 011.414-1.414l.293.293 4.293-4.293a1 1 0 011.414 1.414l-5 5A1 1 0 0114 34zm0 14a1 1 0 01-.707-.293l-1-1a1 1 0 011.414-1.414l.293.293 4.293-4.293a1 1 0 011.414 1.414l-5 5A1 1 0 0114 48z"
        data-original="#4fba6f"
      ></path>
      <path
        fill="#3f5c6c"
        d="M36 17H23a1 1 0 010-2h13a1 1 0 010 2zm-6 5h-7a1 1 0 010-2h7a1 1 0 010 2zm6 9H23a1 1 0 010-2h13a1 1 0 010 2zm-6 5h-7a1 1 0 010-2h7a1 1 0 010 2zm4.91 9H23a1 1 0 010-2h11.91a1 1 0 010 2zM30 50h-7a1 1 0 010-2h7a1 1 0 010 2z"
        data-original="#3f5c6c"
      ></path>
      <path
        fill="#fb7b76"
        d="M57.75 31.25l-6.01-6a4.246 4.246 0 116.01 6z"
        data-original="#fb7b76"
      ></path>
      <path
        fill="#f9eab0"
        d="M41.51 47.51l-.01.01-6.31 1.45a.969.969 0 01-1.17-1.15l1.47-6.32 3.01 3z"
        data-original="#f9eab0"
      ></path>
      <path
        fill="#f0c419"
        d="M51.74 31.26L38.5 44.5l-3.01-3v-.01l13.24-13.23z"
        data-original="#f0c419"
      ></path>
      <path
        fill="#f29c1f"
        d="M38.493 44.5L51.73 31.264l3.01 3.01L41.501 47.51z"
        data-original="#f29c1f"
      ></path>
      <path
        fill="#95a5a5"
        d="M57.76 31.26l-3.01 3.01-3.01-3.01-3.01-3 3-3.01h.01l6.01 6v.01z"
        data-original="#95a5a5"
      ></path>
    </svg>
  );
}

export default Finished;